import { sendEmailVerification, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';
import { apiFetch } from './apiClient';
import { API_BASE } from './config';
import { getAuthActionCodeSettings, isCustomAuthEmailEnabled } from './authEmailSettings';

export async function sendOberoiVerificationEmail(user = auth.currentUser) {
  if (!user) throw new Error('NOT_AUTHENTICATED');
  if (isCustomAuthEmailEnabled()) {
    await apiFetch(`${API_BASE}/api/auth/send-verification`, { method: 'POST' });
    return;
  }
  await sendEmailVerification(user, getAuthActionCodeSettings());
}

export async function sendOberoiPasswordResetEmail(email) {
  const trimmed = (email || '').trim();
  if (!trimmed) throw new Error('Email required');

  if (isCustomAuthEmailEnabled()) {
    const res = await fetch(`${API_BASE}/api/auth/send-password-reset`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: trimmed }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(data.error || 'Failed to send reset email');
    }
    return;
  }

  await sendPasswordResetEmail(auth, trimmed, getAuthActionCodeSettings());
}
